import { defineStore } from "pinia";
import { ref } from "vue";
import { authService } from "@/services/auth.service";
import router from "@/router";

export const useAuthStore = defineStore("auth", () => {
  const user = ref<any>(null);
  const isAuthenticated = ref(false);
  const isLoading = ref(false);

  async function checkAuth() {
    isLoading.value = true;
    try {
      const userData = await authService.getCurrentUser();
      if (userData) {
        user.value = userData;
        isAuthenticated.value = true;
        // Save user email for language preferences
        if (userData.email) {
          localStorage.setItem("userEmail", userData.email);
        }
      } else {
        // Если данных пользователя нет - очищаем состояние
        user.value = null;
        isAuthenticated.value = false;
        localStorage.removeItem("auth_token");
        localStorage.removeItem("userEmail");
      }
    } catch (error) {
      console.error("Auth check failed:", error);
      // При ошибке авторизации очищаем невалидные данные
      user.value = null;
      isAuthenticated.value = false;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userEmail");
    } finally {
      isLoading.value = false;
    }
  }

  async function logout() {
    try {
      await authService.logout();
      user.value = null;
      isAuthenticated.value = false;
      // Clear auth token and user email from localStorage
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userEmail");
      // Используем полную перезагрузку для гарантированной очистки состояния
      window.location.replace("/");
    } catch (error) {
      console.error("Logout failed:", error);
      // Даже если logout не удался на сервере, очищаем локальное состояние
      user.value = null;
      isAuthenticated.value = false;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userEmail");
      window.location.replace("/");
    }
  }

  function login() {
    window.location.href = authService.getLoginUrl();
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    checkAuth,
    logout,
    login,
  };
});
